/**
 * Безопасный вывод текста чата: экранирование HTML + ссылки (URL и [текст](url)).
 */

const MD_LINK_RE = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
const URL_RE = /https?:\/\/[^\s<]+[^\s<.,;:!?'")\]}>]/gi;

export function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function isSafeHref(href) {
  const h = String(href || '').trim();
  return /^https?:\/\//i.test(h);
}

/**
 * @returns {Array<{ type: 'text' | 'link', value: string, href?: string }>}
 */
import React from 'react';

export function parseMessageTextParts(raw) {
  const text = String(raw ?? '');
  if (!text) return [];

  const segments = [];
  let last = 0;
  const re = new RegExp(MD_LINK_RE.source, 'g');
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) {
      segments.push({ kind: 'plain', text: text.slice(last, m.index) });
    }
    const label = m[1] || '';
    const href = m[2] || '';
    if (isSafeHref(href)) {
      segments.push({ kind: 'md', text: label, href });
    } else {
      segments.push({ kind: 'plain', text: m[0] });
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) {
    segments.push({ kind: 'plain', text: text.slice(last) });
  }
  if (!segments.length) {
    segments.push({ kind: 'plain', text });
  }

  const parts = [];
  for (const seg of segments) {
    if (seg.kind === 'md') {
      parts.push({ type: 'link', value: seg.text, href: seg.href });
      continue;
    }
    const plain = seg.text;
    let urlLast = 0;
    const urlRe = new RegExp(URL_RE.source, 'gi');
    let um;
    while ((um = urlRe.exec(plain)) !== null) {
      if (um.index > urlLast) {
        parts.push({ type: 'text', value: plain.slice(urlLast, um.index) });
      }
      const href = um[0];
      if (isSafeHref(href)) {
        parts.push({ type: 'link', value: href, href });
      } else {
        parts.push({ type: 'text', value: href });
      }
      urlLast = um.index + um[0].length;
    }
    if (urlLast < plain.length) {
      parts.push({ type: 'text', value: plain.slice(urlLast) });
    }
  }
  return parts.filter((p) => p.value !== '');
}

export function LinkifiedMessageText({ text, className, linkClassName = 'support-chat-page__message-link' }) {
  const parts = parseMessageTextParts(text);
  if (!parts.length) {
    return React.createElement('span', { className }, '—');
  }
  return React.createElement(
    'span',
    { className },
    parts.map((part, idx) => {
      if (part.type === 'link') {
        return React.createElement(
          'a',
          {
            key: `lnk-${idx}`,
            href: part.href,
            className: linkClassName,
            target: '_blank',
            rel: 'noopener noreferrer',
          },
          part.value,
        );
      }
      return React.createElement(React.Fragment, { key: `txt-${idx}` }, part.value);
    }),
  );
}
